import React, { useState } from 'react'
import {Badge} from '../..'
import { CloseRounded } from '@mui/icons-material'

import './readMore.css'

const ReadMore = ({onOpen, onClose}: any) => {

  return (
    <>
        {onOpen && (
            <>
                <div className='read-more-modal-wrapper'>
                    <div className={onOpen ? "read-more-modal-container active": "read-more-modal-container"}>
                        <Badge title="About Us" />
                        <div className='read-more-close-modal' onClick={onClose}><CloseRounded /></div>
                        <div className='read-more-main-container'>
                            <div className="read-more-main-cover">
                                <h2 className='read-more-header'>Our Mission</h2>
                                <div className='read-more-text'>
                                    A1Care is a dependable provider of healthcare services across most counties in Maryland. We are committed to delivering high-quality care in settings that are most comfortable and convenient for our patients and clients, including private homes, hospitals, physicians’ offices, schools, group homes, nursing homes, daycare centers, and assisted living facilities.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}
    </>
  )
}

export default ReadMore